import React from "react"

function IconEye({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="eye"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-eye"
      {...props}
    >
      <path
        d="M11.943 5.4c3.324 0 6.733 2.71 9.635 6.218a.6.6 0 0 1 0 .765c-2.899 3.51-6.305 6.217-9.635 6.217-3.325 0-6.733-2.71-9.635-6.218a.6.6 0 0 1 0-.765C5.205 8.107 8.611 5.4 11.942 5.4zm0 1.2c-2.577 0-5.459 2.105-7.97 4.918l-.419.481.17.198c2.405 2.763 5.177 4.91 7.7 5.175l.26.021.259.007c2.577 0 5.458-2.105 7.969-4.918l.25-.283.169-.199-.17-.197c-2.404-2.763-5.177-4.91-7.7-5.175l-.26-.021-.258-.007zm0 2.191A3.212 3.212 0 0 1 15.15 12a3.212 3.212 0 0 1-3.208 3.209A3.212 3.212 0 0 1 8.733 12a3.212 3.212 0 0 1 3.21-3.209zm0 1.2A2.012 2.012 0 0 0 9.933 12c0 1.107.903 2.009 2.01 2.009A2.012 2.012 0 0 0 13.95 12a2.012 2.012 0 0 0-2.008-2.009z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconEye
